module.exports = __webpack_public_path__ + "img/VL_14_03.ef859a0d.png";